import React from 'react';
import styles from './HomePage.module.scss';
import MainPoster from './main_poster/component';
import neige from '../../../assets/neige.png';
import back from '../../../assets/Twing-Raid-2027-1.jpg';
import FormEvent from './form_event/component';
import TournamentPoster from './tournament_poster/component';
import { ClassementComponent } from './final_rank/component';


const HomePage: React.FC = () => {
  return ( 
    <>
    <MainPoster />
    {/* <Telethon /> */}  
    {/* <ClassementComponent /> */}
    {/* <div className={styles.main}>
      <img src={back} alt="Background" className={styles.back} />
      <TournamentPoster />
      {/* <FormEvent /> */}
    {/* </div> */} 
    
    </>
  );
};

export default HomePage;
